import { markRaw } from "vue";

const state = {
  modals: [],
};

const mutations = {
  openModal(state, payload) {
    const {
      header,
      body,
      footer,
      headerOptions,
      bodyOptions,
      footerOptions,
      onSubmit,
      onClose,
    } = payload.modalData;

    const data = {};

    if (header) {
      data.header = markRaw(header);
    }

    if (body) {
      data.body = markRaw(body);
    }

    if (footer) {
      data.footer = markRaw(footer);
    }

    if (headerOptions) {
      data.headerOptions = headerOptions;
    }

    if (bodyOptions) {
      data.bodyOptions = bodyOptions;
    }

    if (footerOptions) {
      data.footerOptions = footerOptions;
    }

    if (onSubmit) {
      data.onSubmit = onSubmit;
    }

    if (onClose) {
      data.onClose = onClose;
    }

    const modal = {
      id: Date.now(),
      required: payload.required || false,
      data,
    };

    if (payload.event) {
      modal.clickPosition = {
        x: payload.event.clientX,
        y: payload.event.clientY,
      };
    }

    if (payload.maxWidth) {
      modal.maxWidth = payload.maxWidth;
    }

    if (payload.fromBottom) {
      modal.fromBottom = payload.fromBottom;
    }

    state.modals.push(modal);

    return modal.id;
  },

  closeModal(state, id) {
    const index = state.modals.findIndex((modal) => modal.id === id);

    if (index !== -1) {
      if (state.modals[index].data.onClose) {
        state.modals[index].data.onClose();
      } else {
        state.modals.splice(index, 1);
      }
    }
  },

  closeAllModals(state) {
    state.modals = [];
  },

  changeModalData(state, payload) {
    const modal = state.modals.find((modal) => modal.id === payload.id);
    const modalIndex = state.modals.findIndex(
      (modal) => modal.id === payload.id
    );

    if (!modal || !modalIndex === -1) {
      return;
    }

    const { data } = modal;

    if (payload.header) {
      data.header = markRaw(payload.header);
    }

    if (payload.body) {
      data.body = markRaw(payload.body);
    }

    if (payload.footer) {
      data.footer = markRaw(payload.footer);
    }

    if (payload.headerOptions) {
      data.headerOptions = { ...data.headerOptions, ...payload.headerOptions };
    }

    if (payload.bodyOptions) {
      data.bodyOptions = { ...data.bodyOptions, ...payload.bodyOptions };
    }

    if (payload.footerOptions) {
      data.footerOptions = { ...data.footerOptions, ...payload.footerOptions };
    }

    if (payload.event) {
      state.modals[modalIndex] = {
        ...modal,
        clickPosition: {
          x: payload.event.clientX,
          y: payload.event.clientY,
        },
      };

      data.bodyOptions = { ...data.bodyOptions };
    }

    if (payload.onSubmit) {
      data.onSubmit = payload.onSubmit;
    }
  },
};

export default {
  state,
  mutations,
};
